import { render, staticRenderFns } from "./SettingsControls.vue?vue&type=template&id=2028d8ed&scoped=true&"
import script from "./SettingsControls.vue?vue&type=script&lang=js&"
export * from "./SettingsControls.vue?vue&type=script&lang=js&"
import style0 from "../Style/journey-connection-settings-controls.scss?vue&type=style&index=0&id=2028d8ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028d8ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2028d8ed')) {
      api.createRecord('2028d8ed', component.options)
    } else {
      api.reload('2028d8ed', component.options)
    }
    module.hot.accept("./SettingsControls.vue?vue&type=template&id=2028d8ed&scoped=true&", function () {
      api.rerender('2028d8ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/SettingsControls.vue"
export default component.exports